export function resolveRoutePattern(matches: readonly { fullPath: string }[]): string {
  const leafPath = matches.at(-1)?.fullPath ?? '/'
  return leafPath.length > 1 ? leafPath.replace(/\/$/, '') : leafPath
}
